// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__39ZE0","description":"PatientConsentPreview_description__2Y-kH"};